import React from 'react';
import PropTypes from 'prop-types';
import { LEGEND_VALUES } from 'constants/countryProfile';


function LegendTraffic(props) {
  return (
    <div className={`c-legend-traffic no-print ${props.theme ? props.theme : ''}`}>
      <div>
        <span className="title">Score</span>
        {LEGEND_VALUES.filter(el => !el.mapOnly).map((l, i) => (
          <div key={i} className="legend-item">
            <div className={`color ${l.colorCode}`}></div>
            <div className="label">
              <span>{l.value}</span>
              <span>{l.description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

LegendTraffic.propTypes = {
  theme: PropTypes.string
};

export default LegendTraffic;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/LegendTraffic.jsx